// extracted by mini-css-extract-plugin
module.exports = {"comp":"J_comp__nSEfd"};